
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieConsentBanner from './components/base/CookieConsentBanner';
import './i18n';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsentBanner />
    </BrowserRouter>
  );
}

export default App;
